$eve_app_page_components_chip $eve_app_page_sb_page
	title \Chip
	Head null
	body /
		<= Overview_page $eve_app_page_sb_page
			title null
			body /
				<= Playground $eve_app_page_sb_playground
					component_name \Live_chip
					default_source \
						\Live_chip $eve_chip
						\	label \Filter
						\
